// extracted by mini-css-extract-plugin
export default {"waitingContainer":"waitingContainer--ATVqv"};